<template>
   <div>
    <Suspense>
        <template #fallback>
            <div>loading</div>
        </template>

        <AsyncPreferences 
              :action="preferenceAction"
              :trigger="preferenceTrigger" 
              @return-value="preferenceReturn"
                    />
    </Suspense>
  </div>
  <ion-page id="puzzle-page">
    <AlertReplacement :alertInfo="alertInfo" :trigger="alertTrigger"></AlertReplacement>
 
    <ion-content>
    
      <div v-show="showTour">
        <Tour  :tour="tourInfo" :tourTrigger="tourTrigger" @tour-done="tourDone" />
      </div>

      <div id="the_board" :style="styleBoard">
        <CMChessboard :fen="forceFen" :validMoves="availableMoves" :orientation="orientation" 
                  :boardSize="boardSize" :hint="hintFen" :animateOnePly="animateFen"
                  :animateSequence="revealFenArray" 
                  :setSquareColor="squareColorArray"
                  :reportFromTo="isVisualization || showEyegazeButtons" :resetFromTo="resetFromTo"
                  :pieceSet="pieceSet"
                  @move-animated="moveAnimated"
                  @board-move="boardMove"
                  @board-from-to-tap="boardFromToTap" 
                 />
      </div>
      <div id="the_statusline" :class="{ 'text-dark' : isDark,'text-light' : !isDark }" :style="styleStatusLine">
        {{ puzzleRatingText }}
        <div>
          <span v-if="showThumb == 'down'">
            <ion-icon aria-hidden="true" :icon="thumbsDown" />
          </span>
          <span v-if="showThumb == 'up'">
            <ion-icon aria-hidden="true" :icon="thumbsUp" />
          </span>
          <span v-if="showThumb == 'solved'">
            <ion-icon aria-hidden="true" :icon="star" />&nbsp;
            <ion-icon aria-hidden="true" :icon="star" />
          </span>
          {{ statusLineText }}
          <span v-if="showThumb == 'solved'">
            <ion-icon aria-hidden="true" :icon="star" />&nbsp;
            <ion-icon aria-hidden="true" :icon="star" />
            <span v-if="puzzleTargetCount > 0">
              ({{ puzzleDoneCount }} / {{ puzzleTargetCount }})
            </span>
          </span>
          <span v-if="showThumb == 'down'">
            <ion-icon aria-hidden="true" :icon="thumbsDown" />
          </span>
          <span v-if="showThumb == 'up'">
            <ion-icon aria-hidden="true" :icon="thumbsUp" />
          </span>
        </div>
        <div v-if="puzzleIsTimed">
          {{ timeRemainingDisplayString }}
        </div>
      </div>
      
      <!-- button matrix -->
      <div v-show="showEyegazeButtons && !showingInitialToolbar && (puzzleState == PUZZLE_ACTIVE || doingExplore)" >
        <div id="eyegaze_area" :style="styleMoveHistory">
          <div style="display: inline;">
            <div v-for="row in eyegazeMatrix" >
                <span v-for="col in row.items" >
                  <span v-if="col != null">
                    <span >
                      <ion-button @click="eyegazeClick(col)" 
                            :class="{ 'one-move-button' : col.moves.length == 1,
                                      'multiple-move-button' : col.moves.length > 1,
                                      'single-height' : eyegazeMatrix.length == 4,
                                      'three-fourth-height' : eyegazeMatrix.length == 3,
                                      'double-height' : eyegazeMatrix.length <= 2 }">
                          <ion-img class="chess-image" style="text-align: left;" :src="col.img" alt="Chessvis"></ion-img>
                        <span class="button-text">   {{ col.info }}</span>
                      </ion-button>
                    </span>
                  </span>
                </span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!showEyegazeButtons || showingInitialToolbar || (puzzleState != PUZZLE_ACTIVE && !doingExplore)" >

        <div id="the_movehistory" :style="styleMoveHistory" :class="{ 'text-dark' : isDark,'text-light' : !isDark }">
          <hr class="movelist-eighty-line">

          <div v-if="puzzleState == PUZZLE_NONE && firstPuzzleOfSession">
            <em>{{ t("Current Option Values") }}:</em><br>
            {{ categoryDisplayString }}<br>
            {{ ratingDisplayString }}<br>
            <span v-if="backupDisplayString.length > 0">{{ backupDisplayString }}<br></span>
            <span v-if="timeDisplayString.length > 0">{{ timeDisplayString }} ({{ timerStartDisplayString }} )<br>
            </span>
            <span v-if="blindfoldDisplayString.length > 0">{{ blindfoldDisplayString }}<br></span>
            <span v-if="disableHintButton">{{ t("Hint Button Disabled - by Preferences") }}<br></span>
            <span v-if="showEyegazeButtons">{{ t("Using EyeGaze Buttons") }}<br></span>
          </div>

          <div v-if="moveHistoryStack.length == 0 && visualizeMovesArray.length == 0">
            {{ passantText }}
          </div>
          <div v-if="puzzleIsBlindfold">
            {{ yourPiecesString }}<br>
            {{ opponentPiecesString }}
          </div>
          <div v-if="visualizeMovesArray.length > 0">
            {{ t("Visualize") }}: 
            <MoveHistory :moveHistoryStack="visualizeMovesArray" 
                          :firstMoveColor="visualizationOrientation"
                          :trigger="visualizeTrigger"
                          />
          </div>
          <MoveHistory :moveHistoryStack="moveHistoryStack" 
                        :noAvailableMovesFlag="noAvailableMovesFlag" :firstMoveColor="orientation"
                          :trigger="moveHistoryTrigger" />
        </div>
      </div>
      <div v-if="!showBigButtons">
        <ActionSheet :heading="optionsHeadingTitle" :items="actionSheetButtons" 
                    :trigger="actionSheetTrigger"
                    @action-sheet-result="actionSheetResult">
        </ActionSheet>
      </div>
    </ion-content>
      <Toolbar id="the_toolbar" :elements="toolbarElements" 
                    :trigger="toolbarTrigger" :ignoreClicks="showTour" @toolbar-click="toolbarClick" />
  </ion-page>
</template>

<script setup>

  import { IonIcon,IonPage, IonContent,modalController, IonGrid,IonRow,IonCol,IonImg,IonButton } from '@ionic/vue';
  import { thumbsUp, thumbsDown, star } from 'ionicons/icons';

  import ModalGenericSingleList from '@/components/ModalGenericSingleList.vue'
  import ModalGenericAccordion from '@/components/ModalGenericAccordion.vue'
  import ModalPuzzleRatingRange from '@/components/ModalPuzzleRatingRange.vue'

  import ModalErrorMessage from '@/components/ModalErrorMessage.vue'
  import AlertReplacement from '@/components/AlertReplacement.vue'
  import ModalActionReplacement from '@/components/ModalActionReplacement.vue';

  import party from "party-js";

  import { Chess } from '@/ts/chess.ts'
  import { buildPieceLocationStrings, getPieceSetName , columnToNumber, buildAvailableMoves,
                  buildEyegazeButtons } from '@/composables/blindfoldSupport.js'
  import AsyncPreferences from '@/components/AsyncPreferences.vue'

  import { puzzleCategoryBuilder, puzzleTimeControlBuilder , 
              puzzleWhenTimerStartsBuilder, puzzleVisualizeBuilder,
              puzzleBlindfoldBuilder, puzzleAccordionBuilder } from '@/composables/puzzleSupport';

  import { findToolbarElement, setToolbarElementDisabledFlag, 
                    setToolbarElementLabel, setAllToolbarElementsDisabled, restoreAllToolbarElementsDisabled} 
                from '@/composables/toolbarSupport.js'

  import CMChessboard from '@/components/CMChessboard.vue'
  import ActionSheet from '@/components/ActionSheet.vue'
  import Toolbar from '@/components/Toolbar.vue'
  import MoveHistory from '@/components/MoveHistory.vue'

  import { onMounted, onBeforeUnmount } from 'vue'
  import { ref, watch } from 'vue'
  import { useGetData } from '@/composables/getData.js'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useStringStore } from '@/stores/stringStore';

  import { doStartupCheck } from '@/composables/startupCheck.js'
  import { availableWidthHeight, calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import Tour from '@/components/Tour.vue'
  import { t , replaceMultipleAll } from '@/composables/translateText.js'

  const emit = defineEmits(['next-item-click'])

  const alertInfo = ref({})
  const alertTrigger = ref(0)

  
  const connectionStore = useConnectionStore()

  const isDark = ref(connectionStore.getDarkmode != "light")
  var puzzleType = connectionStore.getProductOption
  //console.log("puzzleType ",puzzleType)

  const whichMenu = localStorage.getItem("whichMenu")
  const showBigButtons = ref(whichMenu == "buttons" || connectionStore.getShowBigButtons)

  // eyegaze is only on regular puzzles
  const showEyegazeButtons = ref(puzzleType == "solveit" && connectionStore.getIsEyeGaze)

  const eyegazeMatrix = ref([[]])
  var isPortrait = true
  var blindnessLevel = 1
  var canUndoBigButtonSelection = false

  const disableHintButton = connectionStore.getDisableHintButton

  const TOOLBAR_GET_PUZZLE = 0
  const TOOLBAR_BACK = 1
  const TOOLBAR_REWIND = 2
  const TOOLBAR_HINT = 3
  const TOOLBAR_REVEAL = 4
  const TOOLBAR_EXPLORE = 5
  const TOOLBAR_OPTIONS = 6 
  const TOOLBAR_DONE = 7

  const INITIAL_FEN = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"

  const MOVEHISTORY_FONTSIZE = 16
  const MOVEHISTORY_HEIGHT =  MOVEHISTORY_FONTSIZE * 1.2 * 3 + 4

  var toolbarPuzzle = [
    { index : TOOLBAR_GET_PUZZLE, label : t("Start") , disabled : false, collapse:false},
    //{ index : TOOLBAR_BACK, label : t("Back") , disabled : true, collapse:false},
    // { index : TOOLBAR_REWIND, label : "Rewind" , disabled : true, collapse:true},
    { index : TOOLBAR_HINT, label : t("Hint") ,disabled : true, collapse:false},
    { index : TOOLBAR_REVEAL, label : t("Reveal") ,disabled : true, collapse:true},
    { index : TOOLBAR_EXPLORE, label : t("Explore") ,disabled : true, collapse:true},
  ]

   var toolbarExplore = [
    { index : TOOLBAR_GET_PUZZLE, label : t("Start") , disabled : false, collapse:false},
    { index : TOOLBAR_BACK, label : t("Back") , disabled : true, collapse:false},
    // { index : TOOLBAR_REWIND, label : "Rewind" , disabled : true, collapse:true},
    { index : TOOLBAR_HINT, label : t("Hint") ,disabled : true, collapse:false},
    //{ index : TOOLBAR_REVEAL, label : t("Reveal") ,disabled : true, collapse:true},
    { index : TOOLBAR_EXPLORE, label : t("Explore") ,disabled : true, collapse:true},
  ]

  const toolbarInitial = [
    { index : TOOLBAR_GET_PUZZLE, label : t("Start") , disabled : false, collapse:false},
    { index : TOOLBAR_OPTIONS, label : t("Options") ,disabled : false, hasAction : true }
  ]

  if (whichMenu == "buttons") {
    toolbarInitial.push({ index : TOOLBAR_DONE, label : t("Done") , disabled : false})
    toolbarExplore.push({ index : TOOLBAR_DONE, label : t("Done") , disabled : false})
    toolbarPuzzle.push({ index : TOOLBAR_DONE, label : t("Done") , disabled : false})
  }

  const PUZZLE_NONE = 0
  const PUZZLE_ACTIVE = 1
  const PUZZLE_FAILED = 2
  const PUZZLE_SOLVED = 3
  var puzzleState = ref(PUZZLE_NONE)

  const showThumb = ref("")

  const menuTrigger = ref(0)
  const tourTrigger = ref(0)
  const tourOption = connectionStore.getTourOption
  //console.log("*** Tour option",tourOption)
  const showTour = ref((tourOption == "show"))

  const windowSizeStore = useWindowSizeStore()
  const noAvailableMovesFlag = ref(0)
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })
  //console.log("**** explorer initial screensize", windowSizeRef.value)
  const boardSize = ref(100)

  var blankAppendTrigger = ""

  const optionsHeadingTitle = ref(t("Options"))

  // for offline puzzles
  const workOfflinePuzzles = connectionStore.getWorkOfflinePuzzles
  const workingOffline = (workOfflinePuzzles == "yes") ? true : false
  
  const preferenceTrigger = ref(0)
  const preferenceAction = ref({})
  const puzzleCountString =  connectionStore.getPuzzleCount
  const puzzleCount = parseInt(puzzleCountString)
  const visualizeCountString =  connectionStore.getVisualizeCount
  const visualizeCount = parseInt(visualizeCountString)
  //console.log("offline puzzle count",puzzleCount,visualizeCount)

  var puzzleIsTimed = ref(puzzleType == "timed" || puzzleType == "timed_visualize")
  var puzzleIsVisualized = ref(puzzleType == "visualize" || puzzleType == "timed_visualize")
  var puzzleIsBlindfold = ref(puzzleType == "blindfold")

  const puzzleFromHistory = (puzzleType == "from_history")
  const puzzleFromHistoryId = connectionStore.getPuzzleHistoryId
  const puzzleFromHistoryRating = connectionStore.getPuzzleHistoryRating

  const toolbarElements = ref((puzzleFromHistory) ? toolbarPuzzle : toolbarInitial)
  var showingInitialToolbar = (puzzleFromHistory) ? false : true

  const ACTION_OPTION_CATEGORY = 0
  const ACTION_OPTION_RATING = 1
  const ACTION_OPTION_VISUALIZE_MOVES = 2
  const ACTION_OPTION_TIMING = 3
  const ACTION_OPTION_WHEN_TIMER_START = 4
  const ACTION_OPTION_BLINDFOLD = 5
 
  const firstPuzzleOfSession = ref(true)
  const passantText = ref("")
  const categoryDisplayString = ref("")
  const ratingDisplayString = ref("")
  const backupDisplayString = ref("")
  const timeDisplayString = ref("")
  const timerStartDisplayString = ref("")
  const blindfoldDisplayString = ref("")

  // OPTIONS Action sheet.  First two are for everyone, then append as needed
  const actionSheetTrigger = ref(0)
  var actionSheetButtons = []
  
  var timeRemainingSeconds = 0
  var timeInitialSeconds = 0
  var timeIncrementSeconds = 0
  var timeRemainingDisplayString = ref("")
  var timeColor = "pick"
  var timerCanStop = false
  var timerHasStarted = false

  // rating bar
  const barMinValue = ref(1000)
  const barMaxValue = ref(2000)

  // only need to get puzzle count once
  var getPuzzleCount = true
  const puzzleDoneCount = ref(0)
  const puzzleTargetCount = ref(0)

  // for blindfold
  var chess = new Chess()
  const yourPiecesString = ref("")
  const opponentPiecesString = ref("")
  const pieceSet = ref("regular")
  var savePieceSet = pieceSet.value
  var boardIsRevealed = false
  var currentBlindfold = 2

  const stringStore = useStringStore()
  
  const puzzleRatingText = ref("If needed, change Options now")
  const statusLineText = ref(puzzleIsVisualized.value ? "(" + t("With Visualization") + ")" : "")

  const forceFen = ref(INITIAL_FEN)
  const hintFen = ref([])
  const animateFen = ref([])
  const revealMoveStack = ref([])
  const revealFenArray = ref([])
  var revealingVisualizedMoves = true
  var fenForDisplay = ""

  var playingWhite = 1
  const orientation = ref("white")

  // save as player's color unless 1 half move
  const visualizationOrientation = ref("black")

  const isVisualization = ref(false)
  const resetFromTo = ref(0)

  const availableMoves = ref([])
  var hiddenAvailableMoves = []

  const validTos = ref([])
  const validFroms = ref([])
  const moveHistoryStack = ref([])
  const moveHistoryTrigger = ref(0)
  const visualizeTrigger = ref(10)
  const moveHistoryString = ref("")
  const toolbarTrigger = ref(0)
  const squareColorArray = ref([])

  var plyNumber = 0
  var moveNumber = 0
  var extraMovesArray = []
  var goodMovesArray = []
  var visualizeMovesArray = ref([])

  var puzzleId = ""
  var catId = ""
  var puzzleRating = 0
  var halfMovesVisualize = ""
  var saveAttemptDone = false
  var numberHints = 0
  var numberBadMoves = 0
  var highestPlyNumberWithGoodMove = 0

  var isTimed = false
  var timerStartOnFirstMove = false
  var puzzleTimeAmount = 0
  var puzzleTimeIncrement = 0;

  // explore stuff

  var doingExploreBack = false
  const doingExplore = ref(false)
  var isExplorePlayerMove = true
  var initialExploreFen = ""
  var bestExploreMoveIndex = 0
  var exploreFenStack = []

  // end explore stuff

  var categoryMap = new Map()

  var optionSaveName = ""
  var optionDisplayArray = []
  var optionDisplaySelected = ""
  var optionHeading = ""

  // which option is being worked on in generic list
  var whichOptionIsGenericList = ""


  // end option stuff

  // tour stuff

  const puzzleIntro = { id: "", title: t("Puzzles"), text : t("Access the 3 million Lichess puzzles.<br><br>Chessvis is the only program that lets you choose both the category AND rating of the puzzles you want to try.<br><br>Want to do hard 5 move puzzles one day and easy 2 move mates the next? Go ahead!")}
  const puzzleMechanics = { id: "", title: t("The Mechanics"), text : t("Make moves on the board by either 'drag and drop' or 'tap and go'.")}
  const puzzleMoveHistory = { id: "the_movehistory", title: t("Moves you've played"), text : t("The move history")}
  const toolbarPuzzleReveal =  { id: "the_toolbar", title: t("Reveal - Toolbar"), text : t("The entire sequence of moves to solve the puzzle are played out")}
  const blindfoldIntro = { id: "", title: t("Blindfold Puzzles"), text : t("How about solving puzzles with a blindfold on?<br><br>Chessvis offers several 'stepping stones' on the way to an empty board")}
  const blindfoldIdea = { id: "", title: t("Blindfold Levels"), text : t("Most people think of an empty board when they hear '<i>blindfold</i>'.<br><br>With Chessvis, you can have all the pieces be of the same color, two color disks, or one color disks plus the 'empty board'")}
  const blindfoldMechanics = { id: "", title: t("Blindfold Mechanics"), text : t("Make moves on the board by either 'drag and drop' or 'tap and go'.<br><br>And yes, even with an 'empty board' there are invisible pieces for you to move around.")}
  const blindfoldMoveHistory = { id: "the_movehistory", title: t("Where the pieces are"), text : t("Here, you'll see a list of where all the pieces are located. It's your job to visualize the board from that list.")}
  const blindfoldLevels = { id: "the_toolbar", title: t("Blindfold Option - Toolbar"), text : t("Start with all the pieces on the board sharing one color. Then move up to 2 color disks, 1 shared color disk and then the empty board.")}

  const visualizationIntro = { id: "", title: t("Puzzle Visualization"), text : t("Chessvis adds a unique twist on puzzles called <b>'visualization'</b>. The board on the screen you see is from some number of moves before the puzzle actually starts.<br><br><i>And while the text that follows describes it, watching the 5 minute video is the way to go.</i>")}
  const timedVisualizationIntro = { id: "", title: t("Timed Puzzle Visualization"), text : t("Chessvis combines a timer with the unique <b>'visualization'</b> twist. The board on the screen you see is from some number of moves before the puzzle actually starts.<br><br><i>And while the text that follows describes it, watching the 5 minute video is the way to go.</i>")}
  const visualizationIdea = { id: "", title: t("The Idea"), text : t("You're told the moves that need to be made before attempting to solve the puzzle. This forces you to solve the puzzle all in your head.<br><br>For example, let's say a puzzle starts on move 50 of a game and you set visualization to 3 moves then the board on the screen will be from the game's move number 47.")}
  const visualizationTask = { id: "", title: t("Your Task"), text : t("You'll be shown the text for the 3 moves needed to get to the puzzle start. You'll need to play those the 3 moves without benefit of updating the board. Then figure out the puzzle solution.")}
  const visualizationMechanics = { id: "", title: t("The Mechanics"), text : t("Since the pieces aren't necessarily on the right square for the puzzle start, you use 'Tap and Go'. Tap on the 'from' and 'to' squares for where the pieces are after the 3 moves have been played.")}
  const visualizationVideo = { id: "", title: t("Did you Watch the Video?"), text : t("It's not that a 2 move mate has turned into a 5 move mate. It's still the same puzzle but you have to 'visualize' the solution.")}
  const visualizationBoard = { id: "the_board", title: t("Tap and Go"), text : t("Since the board is before the puzzle starts, you 'tap' on the square where the piece is now located and then 'tap' on the square where the piece should move to")}
  const visualizationStatus = { id: "the_statusline", title: t("Puzzle Info and Status"), text : t("This area lets you know if your move is good or bad")}
  const visualizationMoveHistory = { id: "the_movehistory", title: t("Moves To Visualize"), text : t("Here are the moves you need to play out in your mind before solving the puzzle.")}

  const timedIntro = { id: "", title: t("Timed Puzzles"), text : t("If you play on-line, you need fast puzzle recognition.<br><br>You don't have time to solve a fancy 5 move puzzle. Nope, you need to solve simpler puzzles faster.")}

  const toolbarStart = { id: "the_toolbar", title: t("Start, Give-Up and Get-Next - Toolbar"), text : t("Retrieve a puzzle")}
  const toolbarBack =  { id: "the_toolbar", title: t("Back - Toolbar"), text : t("Undo a wrong move or Undo a full move")}
  const toolbarRewind = { id: "the_toolbar", title: t("Rewind - Toolbar"), text : t("Restart the puzzle")}
  const toolbarVisualizeHint = { id: "the_toolbar", title: t("Hint - Toolbar"), text : t("The move you're supposed to make is displayed on the status line")}
  const toolbarVisualizeReveal =  { id: "the_toolbar", title: t("Reveal - Toolbar"), text : t("The entire sequence of moves to solve the puzzle including the moves to visualize are played out")}
  const toolbarExploreTour = { id: "the_toolbar", title: t("Explore - Toolbar"), text : t("Curious why a particular move doesn't work? The 'explore' mode enables you to play any move for both sides.<br><br>'Best' moves are suggested by the Stockfish computer engine.")}
  const toolbarCategory = { id: "the_toolbar", title: t("Category Option - Toolbar"), text : t("Select from any one of 60+ puzzle categories")}

  const toolbarRating1 = { id: "the_toolbar", title: t("Rating Option #1 - Toolbar"), text : t("With Chessvis, you can specify a 'target' start rating. As you successfully solve puzzles or miss them, the rating will automatically drift upward and downward.<br><br>You are free to set whatever rating you feel like.")}

  const toolbarRating2 = { id: "the_toolbar", title: t("Rating Option #2 - Toolbar"), text : t("Scroll beyond the target ratings and you'll find 'rating bands'.<br><br>Select among these to limit the puzzles show to ones in that band.")}

  const toolbarMovesToVisualize = { id: "the_toolbar", title: t("# of Moves to Visualize Option - Toolbar"), text : t("You can select from 1 opponent move up through 10 full moves to visualize.")}
  const toolbarTimeControl = { id: "the_toolbar", title: t("Time Control - Toolbar"), text : t("Time to solve the puzzle<br><br>The options range from 10 to 60 seconds.<br><br>There are also time controls with an added 'per move increment'")}
  const visualizeVideo = "https://www.chessvis.com/videos/chessvis_visualization.mp4"

  const puzzleTourInfo = {
    id : "puzzle",
    video : "",
    elements : [
      puzzleIntro,
      puzzleMechanics,
      visualizationStatus,
      puzzleMoveHistory,
      toolbarStart,
      toolbarBack,
      toolbarRewind,
      toolbarVisualizeHint,
      toolbarPuzzleReveal,
      toolbarExploreTour,
      toolbarCategory,
      toolbarRating1,
      toolbarRating2    ]
  }

  const visualizeTourInfo = {
    id : "visualize",
    video : visualizeVideo,
    elements : [
      visualizationIntro,
      visualizationIdea,
      visualizationTask,
      visualizationMechanics,
      visualizationVideo,
      visualizationBoard,
      visualizationStatus,
      visualizationMoveHistory,
      toolbarStart,
      toolbarBack,
      toolbarRewind,
      toolbarVisualizeHint,
      toolbarVisualizeReveal,
      toolbarExploreTour,
      toolbarCategory,
      toolbarRating1,
      toolbarRating2,
      toolbarMovesToVisualize
    ]
  }

  const timedTourInfo = {
    id : "timed",
    video : "",
    elements : [
      timedIntro,
      puzzleMechanics,
      visualizationStatus,
      puzzleMoveHistory,
      toolbarStart,
      toolbarBack,
      toolbarRewind,
      toolbarVisualizeHint,
      toolbarPuzzleReveal,
      toolbarExploreTour,
      toolbarCategory,
      toolbarRating1,
      toolbarRating2,
      toolbarTimeControl
    ]
  }

  const visualizeTimedTourInfo = {
    id : "visualizetimed",
    video : visualizeVideo,
    elements : [
    timedVisualizationIntro,
      visualizationIdea,
      visualizationTask,
      visualizationMechanics,
      visualizationVideo,
      visualizationBoard,
      visualizationStatus,
      visualizationMoveHistory,
      toolbarStart,
      toolbarBack,
      toolbarRewind,
      toolbarVisualizeHint,
      toolbarVisualizeReveal,
      toolbarExploreTour,
      toolbarCategory,
      toolbarRating1,
      toolbarRating2,
      toolbarMovesToVisualize,
      toolbarTimeControl
    ]
  }

  const blindfoldTourInfo = {
    id : "blindfold",
    video : "",
    elements : [
      blindfoldIntro,
      blindfoldIdea,
      blindfoldMechanics,
      visualizationStatus,
      blindfoldMoveHistory,
      toolbarStart,
      toolbarBack,
      toolbarRewind,
      toolbarVisualizeHint,
      toolbarPuzzleReveal,
      toolbarExploreTour,
      toolbarCategory,
      toolbarRating1,
      toolbarRating2,
      blindfoldLevels
    ]
  }

  const tourInfo = ref(visualizeTourInfo)

  const styleStatusLine = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px",
    "text-align" : "center"
  })

  const styleBoard = ref({
    position : "absolute",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleMoveHistory = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px",
    "font-size" : MOVEHISTORY_FONTSIZE + "px",
    "text-align" : "left",
    "line-height" : "1.2em",
    "text-align" : "center"
  })
  
  if (!workingOffline) {
    //getInitialOptions()
    doStartupCheck(false,afterStartupCallbackRoutine)
  }
  else
    afterStartupCallbackRoutine(false,null,null)

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
    if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)
    updateWidthHeights()
    menuTrigger.value++
    resetPuzzleScreen()
  }

  onMounted(() => {
    updateWidthHeights()
  })

  function buildActionSheetButtons() {
    actionSheetButtons = [
        { text: t("Category"), code : "category", current: categoryDisplayString.value,
                          data: { index: ACTION_OPTION_CATEGORY } },
        { text: t("Rating"), code : "rating", current: ratingDisplayString.value, 
                        data: { index : ACTION_OPTION_RATING } },
      ]

    if (puzzleIsVisualized.value)
      actionSheetButtons.push({ text: t("Visualize # Moves"), code: "visualize", current : backupDisplayString.value,
                data: { index :ACTION_OPTION_VISUALIZE_MOVES } })
    if (puzzleIsTimed.value) {
      actionSheetButtons.push({ text: t("Time Control"), code : "time_control", current: timeDisplayString.value,
      data: { index :ACTION_OPTION_TIMING } })
      actionSheetButtons.push({ text: t("When Timer Starts"), code : "timer_start",current: timerStartDisplayString.value,
       data: { index :ACTION_OPTION_WHEN_TIMER_START } })
    }
    if (puzzleIsBlindfold.value)
      actionSheetButtons.push({ text: t("Blindfold Level"), code: "blindfold", current: blindfoldDisplayString.value,
                    data: { index :ACTION_OPTION_BLINDFOLD } })
    if (showBigButtons.value == false)
      actionSheetButtons.push({ text: t('Cancel'), role: 'cancel',data: { index : -1}})
  }

  function updateStyleObjects(boundaries) {
    boardSize.value = boundaries['board'].height

    styleBoard.value.height = boundaries['board'].height + "px"
    styleBoard.value.width = boundaries['board'].width + "px"
    styleBoard.value.top = boundaries['board'].top + "px"
    styleBoard.value.left = boundaries['board'].left + "px"

    styleStatusLine.value.height = boundaries['status'].height + "px"
    styleStatusLine.value.width = boundaries['status'].width + "px"
    styleStatusLine.value.top = boundaries['status'].top + "px"
    styleStatusLine.value.left = boundaries['status'].left + "px"
    
    styleMoveHistory.value.height = boundaries['history'].height + "px"
    styleMoveHistory.value.width = boundaries['history'].width + "px"
    styleMoveHistory.value.top = boundaries['history'].top + "px"
    styleMoveHistory.value.left = boundaries['history'].left + "px"

    const buttonHeight = boundaries['history'].height * .85 / 4
    var element = document.getElementById("eyegaze_area")
    if (element != null) {
      element.style.setProperty("--move_button_size", buttonHeight + "px");
      element.style.setProperty("--move_button_size_x1_33", (1.33 * buttonHeight) + "px");
      element.style.setProperty("--move_button_size_x2", (2 * buttonHeight) + "px");
    }
  }

  function updateWidthHeights() {

    const availableSpace = availableWidthHeight()
    isPortrait = isScreenPortraitOrientation(availableSpace)
    const boundaries = (isPortrait) ? calculatePortraitWidthHeights(availableSpace) :
                                      calculateLandscapeWidthHeights(availableSpace)

    updateStyleObjects(boundaries)
  }

  function calculatePortraitWidthHeights(availableSpace) {

    var textSpace = MOVEHISTORY_HEIGHT + MOVEHISTORY_FONTSIZE * 3 * 1.5

    if (puzzleIsTimed.value)
      textSpace += MOVEHISTORY_FONTSIZE * 1.5
    if (puzzleIsVisualized.value)
      textSpace += 3 * MOVEHISTORY_FONTSIZE * 1.5
    if (puzzleIsBlindfold.value)
      textSpace += MOVEHISTORY_FONTSIZE * 1.5

    // reserve space for status & info
    var availableSpaceForBoard = { width : availableSpace.width ,
                height : availableSpace.height - textSpace,
                isPortrait : true }

    // don't need as big a board for eyegaze
    if (showEyegazeButtons.value)
      availableSpaceForBoard.height *= 0.60

    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const statusPositionTop = boardPositionTop + boardHeight
    const statusPositionLeft = availableSpace.leftRightIndent
    const statusHeight = MOVEHISTORY_HEIGHT
    const statusWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const historyPositionTop = statusPositionTop + statusHeight
    const historyPositionLeft = availableSpace.leftRightIndent
    const historyHeight = availableSpace.height - historyPositionTop
    const historyWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const result = { board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft + availableSpace.leftIndent,
        top : boardPositionTop+ availableSpace.topIndent
      },
      status : {
        width : statusWidth,
        height : statusHeight,
        left : statusPositionLeft + availableSpace.leftIndent,
        top : statusPositionTop+ availableSpace.topIndent
      },
      history : {
        width : historyWidth,
        height : historyHeight,
        left : historyPositionLeft + availableSpace.leftIndent,
        top : historyPositionTop+ availableSpace.topIndent
      }
    }
    //console.log("board and status dimensions",result)
    return (result)
  }

  function calculateLandscapeWidthHeights(availableSpace) {

    // reserve space status message
    const availableSpaceForBoard = { 
                width : (showEyegazeButtons.value) ?  availableSpace.width/2 : availableSpace.width - 150,
                height : availableSpace.height ,
                isPortrait : false }

    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const statusPositionTop = 0
    const statusPositionLeft = boardPositionLeft + boardWidth + availableSpace.leftRightIndent
    const statusHeight = MOVEHISTORY_HEIGHT
    const statusWidth = availableSpace.width - statusPositionLeft

    const historyPositionTop = statusPositionTop + statusHeight
    const historyPositionLeft = statusPositionLeft
    const historyHeight = availableSpace.height - historyPositionTop
    const historyWidth = statusWidth

    const result = { board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft + availableSpace.leftIndent,
        top : boardPositionTop+ availableSpace.topIndent
      },
      status : {
        width : statusWidth,
        height : statusHeight,
        left : statusPositionLeft + availableSpace.leftIndent,
        top : statusPositionTop+ availableSpace.topIndent
      },
      history : {
        width : historyWidth,
        height : historyHeight,
        left : historyPositionLeft + availableSpace.leftIndent,
        top : historyPositionTop+ availableSpace.topIndent
      }
    }
    //console.log("board and status dimensions",result)
    return (result)
  }

  watch(() => connectionStore.getProductOption, () => {
    //console.log("#################### productOption changed ")
    puzzleType = connectionStore.getProductOption
    //console.log("puzzle type flag ",puzzleType)

    resetPuzzleScreen()
    updateWidthHeights()
    menuTrigger.value++

  })

  watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('********** Puzzle -- window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** Puzzle new window size",windowSizeRef.value)
    updateWidthHeights()
    menuTrigger.value++
    tourTrigger.value++
  })

  function resetPuzzleScreen() {
    //console.log("reset puzzle",puzzleType)
    // reset to beginning
    puzzleState.value = PUZZLE_NONE
    firstPuzzleOfSession.value = true

    statusLineText.value = ""
    puzzleIsTimed.value = false
    puzzleIsVisualized.value = false
    puzzleIsBlindfold.value = false
    switch (puzzleType) {
      case "from_history" :
        tourInfo.value = puzzleTourInfo
        break
      case "solveit" :
        tourInfo.value = puzzleTourInfo
        break
      case "visualize" :
        tourInfo.value = visualizeTourInfo
        puzzleIsVisualized.value = true
        statusLineText.value = "(" + t("With Visualization") + ")"
        break
      case "timed" :
        puzzleIsTimed.value = true
        tourInfo.value = timedTourInfo
        break
      case "timed_visualize" :
        tourInfo.value = visualizeTimedTourInfo
        puzzleIsTimed.value = true
        puzzleIsVisualized.value = true
        break
      case "blindfold" :
        puzzleIsBlindfold.value = true
        tourInfo.value = blindfoldTourInfo
        break
    }
    
    puzzleRatingText.value = (workingOffline) ? t("Note: Working Offline") : t("Note: if needed, change Options now")

    if (workingOffline)
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_OPTIONS,true)

    passantText.value = ""
    visualizeMovesArray.value = []
    moveHistoryStack.value = []
    moveHistoryTrigger.value++
    incrementAppendTrigger()
    forceFen.value = INITIAL_FEN + blankAppendTrigger

    if (puzzleType == "from_history")
      manageToolbar("from_history")
    else
      manageToolbar("switch puzzle type")
    showThumb.value = ""

    if (puzzleType == "from_history")
      getPuzzle()
    else
      if (!workingOffline)
        getInitialOptions()
  }

  function undoBadMove() {
    squareColorArray.value = [ ]
    if ((plyNumber % 2) == 1) {
      plyNumber--
      moveHistoryStack.value.pop()
      getAvailableMoves(goodMovesArray[plyNumber].fen)

    }
    else
    if (plyNumber > 0) {
      plyNumber -= 2
      moveHistoryStack.value.pop()
      moveHistoryStack.value.pop()
      if (moveNumber > 1)
        moveNumber--
      getAvailableMoves(goodMovesArray[plyNumber].fen)
    }
    moveHistoryTrigger.value++
    incrementAppendTrigger()
    forceFen.value = goodMovesArray[plyNumber].fen + blankAppendTrigger
    manageToolbar((plyNumber == 0) ? "rewind" : "back")
    statusLineText.value = ""
  }

  function setBadMoveRemoveTimer() {

    let timerSleepAmount = 2000

    function oneInterval() {
      clearInterval(id)

      //console.log("undo bad move")
      undoBadMove()
      //toolbarClick(TOOLBAR_BACK)
    }
    var id = setInterval(oneInterval, timerSleepAmount)
  }

  function manageToolbar(action) {
    //console.log("toolbar action",action)
    switch (action) {
      case "back" :
        if (!disableHintButton)
          setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_HINT,false)
        break
      case "rewind" :
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BACK,true)
        //setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REWIND,true)
        if (!disableHintButton)
          setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_HINT,false)
        break
      case "good move" :
      case "explore move" :
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BACK,false)
        //setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REWIND,false)
        break 
      case "bad move" :
        setBadMoveRemoveTimer()
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BACK,false)
        //setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REWIND,false)
        if (!disableHintButton)
          setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_HINT,true)
        break
      case "reveal start" :
        if (puzzleState.value == PUZZLE_ACTIVE) {
          savePuzzleResult("r")
          puzzleState.value = PUZZLE_SOLVED
        }
        for (var i=0; i < toolbarElements.value.length; i++)
          setToolbarElementDisabledFlag(toolbarElements.value,i,true)
        break
      case "reveal end" :
        setToolbarElementLabel(toolbarElements.value,TOOLBAR_GET_PUZZLE,t("Get-Next"))
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_GET_PUZZLE,false)
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REVEAL,false)
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_EXPLORE,workingOffline)
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_OPTIONS,false)

        break     
      case "from_history" :
        //console.log("in manage -> puzzle from history")
        setToolbarElementLabel(toolbarElements.value,TOOLBAR_GET_PUZZLE,t("Done"))
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BACK,true)
        //setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REWIND,true)
        if (!disableHintButton)
          setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_HINT,true)
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REVEAL,true)
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_EXPLORE,true)
        break
      case "switch puzzle type" :
        //console.log("in manage")
        setToolbarElementLabel(toolbarElements.value,TOOLBAR_GET_PUZZLE,t("Start"))
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BACK,true)
        //setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REWIND,true)

        if (!disableHintButton)
          setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_HINT,true)

        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REVEAL,true)
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_EXPLORE,true)
        break
      case "new puzzle" :
        if (puzzleFromHistory)
          setToolbarElementLabel(toolbarElements.value,TOOLBAR_GET_PUZZLE,t("Done"))
        else
          setToolbarElementLabel(toolbarElements.value,TOOLBAR_GET_PUZZLE,t("Give-Up"))
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BACK,true)
        //setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REWIND,true)

        if (!disableHintButton)
          setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_HINT,false)

        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REVEAL,false)
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_EXPLORE,workingOffline)
        setToolbarElementLabel(toolbarElements.value,TOOLBAR_EXPLORE,t("Explore"))
        break
      case "solved" :
      if (puzzleFromHistory)
          setToolbarElementLabel(toolbarElements.value,TOOLBAR_GET_PUZZLE,t("Done"))
        else
          setToolbarElementLabel(toolbarElements.value,TOOLBAR_GET_PUZZLE,t("Get-Next"))
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_GET_PUZZLE,false)
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BACK,true)
        //setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REWIND,true)

        if (!disableHintButton)
          setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_HINT,true)
        break
      case "explore" :
      if (puzzleState.value == PUZZLE_ACTIVE)
          savePuzzleResult("e")

        toolbarElements.value = toolbarExplore
        if (puzzleFromHistory)
          setToolbarElementLabel(toolbarElements.value,TOOLBAR_GET_PUZZLE,t("Done"))
        else
          setToolbarElementLabel(toolbarElements.value,TOOLBAR_GET_PUZZLE,t("Get-Next"))
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_GET_PUZZLE,false)
        setToolbarElementLabel(toolbarElements.value,TOOLBAR_EXPLORE,t("Review"))
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BACK,true)
        //setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REWIND,true)

        if (!disableHintButton)
          setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_HINT,false)

        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REVEAL,true)

        break
      case "review" :
        toolbarElements.value = toolbarPuzzle
        setToolbarElementLabel(toolbarElements.value,TOOLBAR_EXPLORE,t("Explore"))
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BACK,true)
        //setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REWIND,true)

        if (!disableHintButton)
          setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_HINT,true)

        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REVEAL,false)
        break
      case "explore back" :
        if (!disableHintButton)
          setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_HINT,false)
        break
      case "explore rewind" :
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BACK,true)
        //setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REWIND,true)
        if (!disableHintButton)
          setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_HINT,false)
        break
    }
    toolbarTrigger.value++
  }

  function tourDone() {
    //restoreAllToolbarElementsDisabled(toolbarElements.value)
    //toolbarTrigger.value++
    showTour.value = false
  }

  function doHint() {
    //console.log("in do hint explore,ply#",doingExplore.value,plyNumber)
    if (doingExplore.value) {
      hintFen.value = [exploreFenStack[exploreFenStack.length -1], 
                        availableMoves.value[bestExploreMoveIndex].fen]
      //console.log("hint for explore",hintFen.value)
      statusLineText.value = t("Hint") + " -> " + availableMoves.value[bestExploreMoveIndex].san
    }
    else {
      numberHints++
      if (isVisualization.value == false)
        hintFen.value = [goodMovesArray[plyNumber].fen, goodMovesArray[plyNumber+1].fen]
      statusLineText.value = t("Hint") + " -> " + goodMovesArray[plyNumber].san
    }
  }

  function doReveal(firstpass) {

    if (puzzleIsBlindfold.value)
      pieceSet.value = getPieceSetName(1)

    manageToolbar("reveal start")

    moveHistoryStack.value = []
    moveHistoryTrigger.value++

    revealMoveStack.value = []
    revealFenArray.value = []

    if (firstpass && isVisualization.value && visualizeMovesArray.value.length > 0) {
      revealingVisualizedMoves = true
      statusLineText.value = "Animating Visualized Moves"

      // put the moves to visualize in first and when thoses run out, put in the solution moves
      revealFenArray.value.push(fenForDisplay)
      for (var i=0; i < visualizeMovesArray.value.length; i++) {
        const oneRevealMove = {
          san : visualizeMovesArray.value[i].san,
        }
        revealMoveStack.value.push(oneRevealMove)
        revealFenArray.value.push(visualizeMovesArray.value[i].fen)
      }
    }
    else {
      revealingVisualizedMoves = false
      statusLineText.value = t("Animating Solution")
      // fen at ply # is before the move. so [0] is initial fen, [i+1] is the moving to fen
      // i.e., 1 less san than fen
      for (var i=0; i < goodMovesArray.length; i++) {
        if (i < goodMovesArray.length - 1) {
          const oneRevealMove = {
            san : goodMovesArray[i].san,
          }
          revealMoveStack.value.push(oneRevealMove)
        }
        revealFenArray.value.push(goodMovesArray[i].fen)
      }
    }

    //console.log("reveal move stack ",revealMoveStack.value)
    //console.log("reveal fen array",revealFenArray.value)
  }

  function moveAnimated(arrayIndex) {
    //console.log("move animated ",arrayIndex,revealMoveStack.value[arrayIndex].san)
    moveHistoryStack.value.push(revealMoveStack.value[arrayIndex])
    moveHistoryTrigger.value++

    // if animating visualized moves, switch to puzzle solution
    if (arrayIndex == revealMoveStack.value.length - 1) {
      if (revealingVisualizedMoves) {
        doReveal(false)
      }
      else
        manageToolbar("reveal end")
    }
  }

  function showConfetti() {
    var element = document.getElementById("app")

    party.resolvableShapes["whiteKing"] = "<img src='img/chesspieces/wikipedia/wK.svg'/>"
    party.resolvableShapes["whiteQueen"] = "<img src='img/chesspieces/wikipedia/wQ.svg'/>"
    party.resolvableShapes["blackKing"] = "<img src='img/chesspieces/wikipedia/bK.svg'/>"
    party.resolvableShapes["blackQueen"] = "<img src='img/chesspieces/wikipedia/bQ.svg'/>"

    party.sparkles(element, {
      count: party.variation.range(100, 200),
      speed: party.variation.range(5, 20),
      shapes: ["whiteKing","whiteQueen","blackKing","blackQueen"]
    });
  }
  
  function toolbarClick(index) {

    // *** TESTING
    //throw new Error("Honeybadger source map test - safe to ignore")

    showThumb.value = ""

    // trap that the button should be disabled but the screen hasn't caught up
    var element = findToolbarElement(toolbarElements.value,index)
    if (element != null && element.disabled)
      return

    // reset any good/bad color squares
    squareColorArray.value = [ ]

    switch (index) {
      case TOOLBAR_DONE :
        emit("next-item-click","big_button_menu",t("Big Button Menu"),"buttons")
        break
      case TOOLBAR_OPTIONS :
        //console.log("Click on Options")
        buildActionSheetButtons()
        if (showBigButtons.value)
          openActionReplacementModal()
        else
         actionSheetTrigger.value++
        break
      case TOOLBAR_GET_PUZZLE :
        if (puzzleFromHistory) {
          //console.log("emit")
          emit("next-item-click","puzzle_history_return","Puzzle History","puzzle")
          return
        }
        toolbarElements.value = toolbarPuzzle
        showingInitialToolbar = false

        resetFromTo.value++

        //console.log("click on get puzzle",puzzleState)
        // the label should be "give-up" now
        if (puzzleState.value  == PUZZLE_ACTIVE) {
          savePuzzleResult("g")
          manageToolbar("solved")
          puzzleState.value = PUZZLE_NONE
        }
        else {
          resetFromTo.value++
          getPuzzle()
        }
        break
      case TOOLBAR_BACK :
        if (doingExplore.value) {
          doingExploreBack = true
          exploreFenStack.pop()
          if (exploreFenStack.length == 1)
            manageToolbar("explore rewind")
          else
            manageToolbar("explore back")
          incrementAppendTrigger()
          forceFen.value = exploreFenStack[exploreFenStack.length - 1] + blankAppendTrigger
          moveHistoryStack.value.pop()
          moveHistoryTrigger.value++
          isExplorePlayerMove = !isExplorePlayerMove
          getAvailableMoves(exploreFenStack[exploreFenStack.length - 1] )
          getExplorerMove()
          return
        }
        break
      case TOOLBAR_REWIND :
        if (doingExplore.value) {
          exploreFenStack = [initialExploreFen]
          manageToolbar("explore rewind")
          incrementAppendTrigger()
          forceFen.value = exploreFenStack[exploreFenStack.length - 1] + blankAppendTrigger
          moveHistoryStack.value = []
          moveHistoryTrigger.value++
          isExplorePlayerMove = true
          getAvailableMoves(exploreFenStack[exploreFenStack.length - 1] )
          getExplorerMove()
          return
        }
        plyNumber = 0
        moveNumber = 1
        incrementAppendTrigger()
        forceFen.value = goodMovesArray[0].fen + blankAppendTrigger
        manageToolbar("rewind")
        getAvailableMoves(goodMovesArray[0].fen)
        moveHistoryStack.value = []
        moveHistoryTrigger.value++
        statusLineText.value = ""
        break
      case TOOLBAR_HINT :
        if (!disableHintButton)
          doHint()
        break
      case TOOLBAR_REVEAL :

        // using the Reval button as the "Undo" while move in progress
        if (canUndoBigButtonSelection) {
            getAvailableMoves(goodMovesArray[plyNumber].fen)
            canUndoBigButtonSelection = false
            setToolbarElementLabel(toolbarElements.value,TOOLBAR_REVEAL,t("Reveal"))
            toolbarTrigger.value++
        }
        else
          doReveal(true)
        break
      case TOOLBAR_EXPLORE :
        if (puzzleIsBlindfold.value)
          pieceSet.value = getPieceSetName(1)
        if (doingExplore.value) {
          isVisualization.value = (visualizeMovesArray.value.length > 0)
          doingExplore.value = false
          manageToolbar("review")
          availableMoves.value = []
          statusLineText.value = ""
          incrementAppendTrigger()
          forceFen.value += blankAppendTrigger
        }
        else {
          if (puzzleState.value == PUZZLE_ACTIVE)
            savePuzzleResult("e")
          puzzleState.value = PUZZLE_NONE
          isVisualization.value = false
          isExplorePlayerMove = true
          doingExplore.value = true
          plyNumber = 0
          moveNumber = 1
          manageToolbar("explore")
          statusLineText.value = t("Getting Initial Score")
          incrementAppendTrigger()
          initialExploreFen = goodMovesArray[0].fen + blankAppendTrigger

          incrementAppendTrigger()
          forceFen.value += blankAppendTrigger

          exploreFenStack = [initialExploreFen]
          getAvailableMoves(initialExploreFen)
          getExplorerMove()
        }
        incrementAppendTrigger()
        forceFen.value = goodMovesArray[0].fen + blankAppendTrigger
        
        moveHistoryStack.value = []
        moveHistoryTrigger.value++
        break
    }
  }

  function getAvailableMoves(fen) {
    var fenPieces = fen.trim().split(" ")
    //console.log("fen pieces",fenPieces)
    fenPieces[5] = 1
    const fenFixed = fenPieces.join(" ")
    //console.log("in getavailbe moves",fenFixed)
    chess.load(fenFixed)
    const moves = chess.moves({ verbose: true })
    availableMoves.value = buildAvailableMoves(moves,false)
    //console.log("available moves in getavailablemoves",availableMoves.value)

    if (showEyegazeButtons.value) {
      eyegazeMatrix.value = buildEyegazeButtons(moves,isPortrait,blindnessLevel)
      //console.log("*** eyegaze matrix",eyegazeMatrix.value)
    }
  }

  function incrementAppendTrigger() {
    if (blankAppendTrigger.length > 64)
      blankAppendTrigger = ""
    blankAppendTrigger += " "
  }

  function startTimer() {
    timeRemainingDisplayString.value = timeRemainingSeconds + " " + t("seconds")
    timerHasStarted = true

    function oneSecondInterval() {
      if (timerCanStop) {
        clearInterval(id)
        timerHasStarted = false
        return
      }
      timeRemainingSeconds--
      if (timeRemainingSeconds <= 0) {
        timeRemainingDisplayString.value = t("Out of Time")
        clearInterval(id)
        timerHasStarted = false
        savePuzzleResult("t")
      }
      else {
        timeRemainingDisplayString.value = timeRemainingSeconds + " " + t("seconds")
      }
    }
    var id = setInterval(oneSecondInterval, 1000)
  }

  function buildInitialPieceDisplay() {
    const board = chess.board()
    const strings = buildPieceLocationStrings(board,(orientation.value == "white"))

    yourPiecesString.value = strings.your
    opponentPiecesString.value = strings.opponent
  }
  
  function processJsonResponse (json) {
    //console.log(" get puzzle callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    if (timerStartOnFirstMove)
      timeRemainingDisplayString.value = t("Timer Waiting")

    doingExplore.value = false
    
    moveHistoryStack.value = []
    moveHistoryTrigger.value++

    puzzleState.value = PUZZLE_ACTIVE
    manageToolbar("new puzzle")

    plyNumber = 0
    moveNumber = 1
    extraMovesArray = []
    goodMovesArray = []
    visualizeMovesArray.value = []
    availableMoves.value = []

    const whatColor = json['color']
    orientation.value = (whatColor == 'w') ? "white" : "black"
    visualizationOrientation.value = orientation.value

    saveAttemptDone = false
    numberHints = 0
    numberBadMoves = 0

    // only get puzzle_count once
    if (getPuzzleCount) {
      puzzleDoneCount.value = parseInt(json['puzzle_done_count'])
      puzzleTargetCount.value = parseInt(json['puzzle_target_count'])
      getPuzzleCount = false
    }

    puzzleId = json['fenid']
    puzzleRating = json['rating']
    catId = json['catid']

    if (puzzleIsVisualized.value) {
      halfMovesVisualize = json['half_moves_visualize']

      // one half move is the opponent color
      if (halfMovesVisualize == 1)
        visualizationOrientation.value = (orientation.value == "white") ? "black" : "white"
    }
    else
      halfMovesVisualize = ""

    const playerRating = json['player_rating']
    const visualizeBeginText = json['visualize_begin_text']
    const visualizeMoveText = json['visualize_move_text']

    const ratingString = json['display'].substring(json['display'].indexOf(':') + 1);
    const displayColor = (whatColor == "w") ? "White" : "Black"
    statusLineText.value = t("You") + " (" + playerRating + ") " + t("Play") + " " + t(displayColor)
    if (puzzleIsVisualized.value)
      statusLineText.value += " (" + t("click 'From' square") + ")"
    puzzleRatingText.value = t("Puzzle Rating") + ":" + ratingString

    const hasExtras = json['has_extras']
    if (hasExtras == "y") {
      const extraFens = json['extra_fens'].split(",")
      const extraFroms = json['extra_froms'].split(",")
      const extraTos = json['extra_tos'].split(",")
      const extraSans = json['extra_sans'].split(",")

      for (var i=0; i < extraFens.length; i++) {
        const oneExtra = { fen : extraFens[i],
                          from : extraFroms[i],
                          to : extraTos[i],
                          san : extraSans[i] }
        extraMovesArray.push(oneExtra)
      }
    }

    const fens = json['fens'].split(",")
    const froms = json['froms'].split(",")
    const tos = json['tos'].split(",")
    const sans = json['sans'].split(",")

    for (var i=0; i < fens.length; i++) {
      const oneMove = { fen : fens[i],
                          from : froms[i],
                          to : tos[i],
                          san : sans[i] }
      goodMovesArray.push(oneMove)
    }
    
    //console.log("Good Moves",goodMovesArray)

    getAvailableMoves(goodMovesArray[0].fen)

    if (halfMovesVisualize > 0) {
      isVisualization.value = true
      fenForDisplay = json['fen_for_display']

      incrementAppendTrigger()
      forceFen.value = fenForDisplay + blankAppendTrigger
      const visualizeFens = json['visualize_fens'].split(",")
      const visualizeFroms = json['visualize_froms'].split(",")
      const visualizeTos = json['visualize_tos'].split(",")
      const visualizeSans = json['visualize_sans'].split(",")
      
      for (var i=0; i < visualizeFens.length; i++) {
        const oneVisualize = { fen : visualizeFens[i],
                            from : visualizeFroms[i],
                            to : visualizeTos[i],
                            san : visualizeSans[i] }
        visualizeMovesArray.value.push(oneVisualize)
      }
    }
    else {
      // can now have visualization with the raw puzzle and no backup moves
      isVisualization.value = puzzleIsVisualized.value
      incrementAppendTrigger()
      forceFen.value = goodMovesArray[0].fen + blankAppendTrigger
    }

    visualizeTrigger.value++

    // see if there is an en passant on first move
    const fenChunks = forceFen.value.split(" ")
    if (fenChunks.length > 3 && fenChunks[3] != "-") {
      passantText.value = "Opponent's move created an En Passant at -> " + fenChunks[3]
    }
    else
      passantText.value = ""

    //console.log("********* is visualize",isVisualization.value)

    if (puzzleIsTimed.value) {
      timeColor = json['lichess_time_color']
      timeInitialSeconds = parseInt(json['lichess_time'])
      timeRemainingSeconds = timeInitialSeconds
      timeIncrementSeconds = parseInt(json['lichess_increment'])
      timerCanStop = false
      if (timerStartOnFirstMove == false)
        startTimer()
    }

    if (puzzleIsBlindfold.value) {
      currentBlindfold = json['blindfold']
      // build the white & black piece position strings
      var fenPieces = goodMovesArray[0].fen.split(" ")
      fenPieces[5] = "1"
      const fenForChessJs = fenPieces.join(" ")
      chess.load(fenForChessJs)
      buildInitialPieceDisplay()

      pieceSet.value = getPieceSetName(currentBlindfold)
    }
  }

  function preferenceReturn(action,key,value) {
    //console.log("**************** RETURN FROM PREFERENCES ",action,key,value)

    // if a 'get' then it is a puzzle.  if a 'set' then it is an attempt being saved
    if (action == "get") {
      const json = JSON.parse(value)
      processJsonResponse(json)
    }
  }

  function getPuzzle() {      
    firstPuzzleOfSession.value = false  

    if (workingOffline) {
      if ((puzzleIsVisualized.value)) {
        if (visualizeCount == 0)
          return
        const nextIndexString = connectionStore.getVisualizeNext
        
        preferenceAction.value = { action : "get", key : "visualize" + nextIndexString, value : ""}
        preferenceTrigger.value++
        
        // update next Index
        var nextIndex = parseInt(nextIndexString) + 1
        if (nextIndex == visualizeCount)
          nextIndex = 0
        connectionStore.setVisualizeNext(nextIndex)
      }
      else {
        if (puzzleCount == 0)
          return
        const nextIndexString = connectionStore.getPuzzleNext
        
        preferenceAction.value = { action : "get", key : "puzzle" + nextIndexString, value : ""}
        preferenceTrigger.value++
        
        // update next Index
        var nextIndex = parseInt(nextIndexString) + 1
        if (nextIndex == puzzleCount)
          nextIndex = 0
        connectionStore.setPuzzleNext(nextIndex) 
      }
      return
    }

    const timeNow = Math.floor(Date.now() / 1000)

    var formData = {
      get_offline : 0,
      do_count : (getPuzzleCount) ? 1 : 0,
      device_time : timeNow,
      is_timed : (puzzleIsTimed.value) ? 1 : 0,
      is_backup : (puzzleIsVisualized.value) ? 1 : 0,
      timed_color : timeColor,
      do_over_puzzleid : (puzzleFromHistory) ? puzzleFromHistoryId : 0,
      is_blindfold : (puzzleIsBlindfold.value) ? 1 : 0
    }

    //console.log("before get puzzle post -> ",formData)

    useGetData("chessvis_get_puzzles.php", formData, processJsonResponse)

  }

  function processSavePuzzleResultJsonResponse (json) {
    //console.log(" get puzzle callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }
  }
  function savePuzzleResult(status) {        

    //console.log("****** save puzzle result",status)
    timerCanStop = true
    if (saveAttemptDone)
      return
    
    saveAttemptDone = true

    var formData = {
      version : "A",
      rating : puzzleRating,
      catid : catId,
      puzzleid : puzzleId,
      is_visualized : (puzzleIsVisualized.value) ? "1" : "0",
      timer_start_first_move : (timerStartOnFirstMove) ? "1" : "0",
      half : halfMovesVisualize,
      best : parseInt(highestPlyNumberWithGoodMove/2),
      quick : timeInitialSeconds,
      increment : timeIncrementSeconds,
      why : status,
      clean : (numberHints == 0 && numberBadMoves == 0) ? 1 : 0,
      blindfold : (puzzleIsBlindfold.value) ? currentBlindfold : 0,
      do_over : (puzzleFromHistory) ? "1" : "0",
      do_over_rating : (puzzleFromHistory) ? puzzleFromHistoryRating : ""
    }

    if (workingOffline) {
      // stringify what would normally be sent to server and increment attempt count
      const jsonString = JSON.stringify(formData)

      const attemptCountString = connectionStore.getPuzzleAttemptCount
        
      preferenceAction.value = { action : "set", key : "puzzleAttempt" + attemptCountString, 
                      value : jsonString}
      preferenceTrigger.value++
        
      // update the attempt count
      var newCount = parseInt(attemptCountString) + 1
      connectionStore.setPuzzleAttemptCount(newCount)
      return
    }

    //console.log("before save result post -> ",formData)

    useGetData("chessvis_puzzle_set_attempt.php", formData, processSavePuzzleResultJsonResponse)

  }

  function makeBoardMove(arrayIndex,fromUCI,toUCI,fromNumber,toNumber) {
    if (doingExplore.value) {
      processExploreBoardMove(arrayIndex)
      return
    }

    //console.log("Make board move ")

    if (puzzleIsTimed.value && timerHasStarted == false && timerStartOnFirstMove)
      startTimer()

    //console.log("make board move from to",fromNumber,toNumber)
    const isLastMove = (plyNumber == goodMovesArray.length - 2)

    // is this legal but the wrong move?
    if (fromNumber != goodMovesArray[plyNumber].from || toNumber != goodMovesArray[plyNumber].to) {
      // if last move then check the extras
      var isExtra = false
      if (isLastMove) {
        for (var i=0; i < extraMovesArray.length; i++)
          if (fromNumber == extraMovesArray[i].from && toNumber == extraMovesArray[i].to) {
            isExtra = true
            break
          }
      }
      if (isExtra == false) {
        plyNumber++
        numberBadMoves++
        statusLineText.value = "Wrong Move"
        showThumb.value = "down"
        squareColorArray.value = [ { square : toUCI , color : "red"}]
        manageToolbar("bad move")
        //console.log("available move",availableMoves.value[arrayIndex])
        moveHistoryStack.value.push(availableMoves.value[arrayIndex])
        //console.log("move history stack",moveHistoryStack.value)
        moveHistoryTrigger.value++ 
        return
      }
    }

    // good move

    if (numberBadMoves == 0 && numberHints == 0 && plyNumber > highestPlyNumberWithGoodMove)
      highestPlyNumberWithGoodMove = plyNumber + 2

    // last move?
    if (isLastMove) {
      if (puzzleState.value == PUZZLE_ACTIVE) {

        // if counting puzzles && clean solution, increment count
        if (puzzleTargetCount.value > 0 && numberBadMoves == 0 && numberHints == 0) {
          puzzleDoneCount.value++
          if ((puzzleDoneCount.value % puzzleTargetCount.value) == 0)
            showConfetti()
        }
        savePuzzleResult("c")         // c = congrats
        puzzleState.value = PUZZLE_SOLVED
        manageToolbar("solved")
      }
      showThumb.value = "solved"
      statusLineText.value = t("SOLVED")
      squareColorArray.value = [ { square : toUCI , color : "lightgreen" /* "#5EBC5E"*/}]
      moveHistoryStack.value.push(goodMovesArray[plyNumber])
      moveHistoryTrigger.value++ 

      // clear the matrix
      availableMoves.value = []
      eyegazeMatrix.value = [[]]
    }
    else {
      if (puzzleIsTimed.value && timeIncrementSeconds)
        timeRemainingSeconds += timeIncrementSeconds

      manageToolbar("good move")
      showThumb.value = "up"
      // good move, animate the opponent move
      statusLineText.value = "Good move"
      animateFen.value = [goodMovesArray[plyNumber+1].fen, goodMovesArray[plyNumber+2].fen]
      moveHistoryStack.value.push(goodMovesArray[plyNumber])
      moveHistoryStack.value.push(goodMovesArray[plyNumber+1])
      moveHistoryTrigger.value++ 
      getAvailableMoves(goodMovesArray[plyNumber+2].fen)

      //console.log("move history ",moveHistoryStack.value)
      plyNumber += 2
      moveNumber++

    }
  }

   function eyegazeClick(eyegazeInfo) {
    //console.log("BUTTON CLICKED", eyegazeInfo.moves,availableMoves.value.length)
    //console.log("button move",eyegazeInfo.moves[0])
    //console.log("want fen",eyegazeInfo.moves[0].after)
    //console.log("available moves",availableMoves.value)
    if (eyegazeInfo.moves.length == 1) {
      for (var i=0; i < availableMoves.value.length; i++)
        if (eyegazeInfo.moves[0].after == availableMoves.value[i].fen.trim()) {
          //console.log("*** BUTTON MOVE MATCH",i,availableMoves.value[i])
          const matchedMove = availableMoves.value[i]
          animateFen.value = [matchedMove.chessjs.before, matchedMove.chessjs.after]

          canUndoBigButtonSelection = false
          setToolbarElementLabel(toolbarElements.value,TOOLBAR_REVEAL,t("Reveal"))
          toolbarTrigger.value++

          boardMove(i,matchedMove.chessjs.from,matchedMove.chessjs.to,matchedMove.from, matchedMove.to)
          break
        }
    }
    else {
      canUndoBigButtonSelection = true
      eyegazeMatrix.value = buildEyegazeButtons(eyegazeInfo.moves,isPortrait,blindnessLevel)

      // use the "Reval" button as the Undo
      setToolbarElementLabel(toolbarElements.value,TOOLBAR_REVEAL,t("Undo"))
      toolbarTrigger.value++
    }

  }

  function boardMove(arrayIndex,fromUCI,toUCI,fromNumber,toNumber) {
    //console.log("legal move click",arrayIndex,fromUCI,toUCI,fromNumber,toNumber)
    makeBoardMove(arrayIndex,fromUCI,toUCI,fromNumber,toNumber)
  }

  function boardFromToTap(fromNumber,toNumber,fromUCI,toUCI) {

    // if eyegaze, ignore 
    if (showEyegazeButtons.value)
      return

    //console.log("boardFromToTap",fromNumber,toNumber,fromUCI,toUCI)

    //console.log("***** plynumber   goodmoves length",plyNumber,goodMovesArray.length)
    //console.log("***** goodmoves ",goodMovesArray[plyNumber])
    if (puzzleState.value != PUZZLE_ACTIVE)
      return

    if (puzzleIsTimed.value && timerHasStarted == false && timerStartOnFirstMove)
      startTimer()

    if (toNumber == -1) {
      showThumb.value = ""
      statusLineText.value = "Move From " + fromUCI
      return
    }

    // clicking on same square clears it
    if (fromNumber == toNumber) {
      resetFromTo.value++
      statusLineText.value = "Move Cleared"
      return
    }

    const isLastMove = (plyNumber == goodMovesArray.length - 2)
    var isExtra = false
  
    if (fromNumber != goodMovesArray[plyNumber].from || toNumber != goodMovesArray[plyNumber].to) {
      // if last move then check the extras
      if (isLastMove) {
        for (var i=0; i < extraMovesArray.length; i++)
          if (fromNumber == extraMovesArray[i].from && toNumber == extraMovesArray[i].to) {
            isExtra = true
            break
          }
      }
    }

    // is the from/to correct? (or an extra on the last move)
    if (isExtra || (fromNumber == goodMovesArray[plyNumber].from && 
                      toNumber == goodMovesArray[plyNumber].to)) {

      if (isLastMove) {
        if (puzzleState.value == PUZZLE_ACTIVE) {

          // if counting puzzles && clean solution, increment count
          if (puzzleTargetCount.value > 0 && numberBadMoves == 0 && numberHints == 0) {
            puzzleDoneCount.value++
            if ((puzzleDoneCount.value % puzzleTargetCount.value) == 0)
              showConfetti()
          }
          savePuzzleResult("c")         // c = congrats
          puzzleState.value = PUZZLE_SOLVED
        }
        statusLineText.value = "Solved: " + fromUCI + " to " + toUCI
        squareColorArray.value = [ { square : toUCI , color : "lightgreen" /* "#5EBC5E"*/}]
        moveHistoryStack.value.push(goodMovesArray[plyNumber])
        moveHistoryTrigger.value++ 

        showThumb.value = "solved"
        manageToolbar("solved")
      }
      else {
        showThumb.value = "up"
        statusLineText.value = "Good Move: " + fromUCI + " to " + toUCI
        moveHistoryStack.value.push(goodMovesArray[plyNumber])
        moveHistoryStack.value.push(goodMovesArray[plyNumber+1])

        plyNumber += 2
        const legalMoveIndex = plyNumber / 2 + 1

        // load up the next available moves
        getAvailableMoves(goodMovesArray[plyNumber+1].fen)
    
        //console.log("avaiable moves",availableMoves.value)
      }
      moveHistoryTrigger.value++ 
      return
    }

    // is a legal move?
    //console.log(availableMoves.value)
    showThumb.value = "down"
    numberBadMoves++
    for (var i = 0; i < availableMoves.value.length; i++)
      if (fromNumber == availableMoves.value[i].from && 
                        toNumber == availableMoves.value[i].to) {
        statusLineText.value = "Wrong Move: " + fromUCI + " to " + toUCI
        return
      }
    statusLineText.value = "Bad Move: "  + fromUCI + " to " + toUCI
  }

  // explorer stuff

  function processExploreBoardMove(arrayIndex) {
    //console.log("explore board move",arrayIndex,availableMoves.value.length)
    exploreFenStack.push(availableMoves.value[arrayIndex].fen)
    moveHistoryStack.value.push(availableMoves.value[arrayIndex])
    moveHistoryTrigger.value++
    manageToolbar("explore move")
    isExplorePlayerMove = !isExplorePlayerMove
    getAvailableMoves(availableMoves.value[arrayIndex].fen)
    getExplorerMove()
  }

  function processExploreJsonResponse (json) {
    //console.log("explore pluzzle callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    const replacementStrings = [
      ["~universal_black_string~", t("Black")],
      ["~universal_white_string~", t("White")],
      ["~server_checkmate~", t("Checkmate")],
      ["~server_mate_in_1~", t("Mate in 1")],
      ["~server_mate_in~",t("Mate in")],
      ["~server_by~",t("by")],
      ["~server_stalemate~",t("Stalemate")],
      ["~server_draw~",t("Draw")],
      ["~server_other~",t("Other")],
      ["~server_unknown~",t("unknown response from engine")]
    ]

    // availableMoves.value = []

    const legalFens = json['legal_fens'].split(",")
    // const legalFroms = json['legal_froms'].split(",")
    // const legalTos = json['legal_tos'].split(",")
    // const legalSans = json['legal_sans'].split(",")

    // for (var i=0; i < legalFens.length; i++) {
    //   const oneLegal = { fen : legalFens[i],
    //                       from : legalFroms[i],
    //                       to : legalTos[i],
    //                       san : legalSans[i] }
    //   availableMoves.value.push(oneLegal)
    // }

    // the "best move index" is based on what server sent back, not the chess.js generated available moves
    // if not -1, adjust it
    bestExploreMoveIndex = json["best_move_index"]
    statusLineText.value = replaceMultipleAll(json["status"],replacementStrings)

    if (bestExploreMoveIndex != -1) {
      // only look at the board part for a match
      const legalFenParts = legalFens[bestExploreMoveIndex].split(" ")
      //console.log("**** Legal Fen Parts",legalFenParts)
      for (var i=0; i < availableMoves.value.length; i++) {
        const availableFenParts = availableMoves.value[i].fen.split(" ")
        if (availableFenParts[0] == legalFenParts[0]) {
          bestExploreMoveIndex = i
          break
        }
      }
      if (isExplorePlayerMove == false)
        if (doingExploreBack == false)
          hintFen.value = [exploreFenStack[exploreFenStack.length -1], 
                        availableMoves.value[bestExploreMoveIndex].fen]
        else
          doingExploreBack = false

    }
    else {
      if (!disableHintButton)
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_HINT,true)
      toolbarTrigger.value++
    }
  }

  function getExplorerMove() {        

    var formData = {
      fen : exploreFenStack[exploreFenStack.length -1],
      player_move : (isExplorePlayerMove) ? "1" : "0"
    }

    //console.log("****** before post in explore -> ",formData)

    useGetData("chessvis_puzzle_explore_move.php", formData, processExploreJsonResponse)

  }

  // stuff for options

  // Start ACTION LIST
  function actionSheetResult(action,index) {
    if (action != "yes")
      return
    actionClick(index)
  }

  function actionClick(index) {
    switch (index) {
      case ACTION_OPTION_CATEGORY :
        getOptions("category")
        break
      case ACTION_OPTION_RATING :
        getOptions("rating")
        break
      case ACTION_OPTION_VISUALIZE_MOVES :
        getOptions("backup")
        break
      case ACTION_OPTION_TIMING :
        getOptions("time")
        break
      case ACTION_OPTION_WHEN_TIMER_START :
        getOptions("when_timer_start")
        break
      case ACTION_OPTION_BLINDFOLD :
        getOptions("blindfold")
        break
    }
  }

  // END Action List

  // START ACTION SHEET REPLACMENT

   function delayBeforeShowingOption(optionId) {

    let timerSleepAmount = 250

    function oneInterval() {
      clearInterval(id)
      actionClick(optionId)
    }
    var id = setInterval(oneInterval, timerSleepAmount)
  }

 const openActionReplacementModal = async () => {
    //console.log("in action replacement",actionSheetButtons)
    const modal = await modalController.create({
      component: ModalActionReplacement,
      componentProps: {
        displayArray : actionSheetButtons,
        title : t("Options")  
       }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    // need a delay so it doesn't look odd and generate errors
    if (role === 'selected') {
      delayBeforeShowingOption(data)
    }
  };

  // END ACTION SHEET REPLACEMENT

  // START Generic Options List

  const openGenericSingleListModal = async () => {
    const modal = await modalController.create({
      component: ModalGenericSingleList,
      componentProps: {
        displayArray : optionDisplayArray,
        initialValue : optionDisplaySelected,
        title : optionHeading      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      // did user leave the select the same?
      if (data.selected == optionDisplaySelected)
        return

      //console.log("CONFIRM in single",data)

      setOptions(data.selected)
   }
  };

  const openGenericAccordionModal = async () => {

    const returnObject = puzzleAccordionBuilder(true,
                    categoryMap,optionDisplaySelected)
    var accordionLabels = returnObject.accordion
    const initialOpenArray = returnObject.initialOpenArray

    //console.log("from puzzleAccordionBuilder",accordionLabels,initialOpenArray)
    const modal = await modalController.create({
      component: ModalGenericAccordion,
      componentProps: {
        accordionLabels : accordionLabels,
        displayArray : optionDisplayArray,
        initialValue : optionDisplaySelected,
        accordionsToOpen : initialOpenArray,
        title : optionHeading      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
     // did user leave the select the same? (And didn't change the favorites list either?)
      if (data.selected == optionDisplaySelected && !data.favoritesChanged)
        return

      //console.log("CONFIRM in accordion",data)
      //console.log("CONFIRM in accordion selected",data.selected)

      // slap the selected and favorites together
      const forServerString = data.selected + "\t" + data.favoritesString
      setOptions(forServerString)
    }
  };

  const openRatingModal = async (ratingInfo) => {
    const modal = await modalController.create({
      component: ModalPuzzleRatingRange,
      componentProps: {
        ratingInfo : ratingInfo
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {

      //console.log("CONFIRM",data)

      var forServer = [data.lower, data.upper, data.singleRating]
      forServer.push( (data.showRange) ? 2 : 1)

      const forServerString = forServer.join(",")

      setOptions(forServerString)
    }
  };

  // END Generic Options List
  
  function processOptionJsonResponse(json) {
    //console.log(" get puzzle option callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    const initial = json["initial"]

    optionDisplayArray = []

    switch (optionSaveName) {
      case "category" :
        const catids = json['catids'].split(",")
        const counts = json['counts'].split(",")

        const favoritesString = json['favorites']
        const favorites = (favoritesString.length > 0) ? 
                        favoritesString.split(",") : []

        const returnObject = puzzleCategoryBuilder(catids,counts,favorites)
        categoryMap = returnObject.map
        optionDisplayArray = returnObject.display

        optionDisplaySelected = "" + initial
        openGenericAccordionModal()
        break
      case "rating" :
        const puzzleCountsStrings = json["puzzle_counts"].split(",")
        var puzzleCounts = []
        for (var i=0; i < puzzleCountsStrings.length; i++)
          puzzleCounts.push(Number(puzzleCountsStrings[i]))
        const ratingInfo = {
          puzzleCounts : puzzleCounts,
          currentRating : Number(json['current_rating']),
          oldRatingRange : Number(json['old_rating_range']),
          minRating : Number(json['min_rating']),
          maxRating : Number(json['max_rating']),
          selectUserRating : Number(json['select_user_rating'])
        }
        openRatingModal(ratingInfo)
        break
      case "time" :
        const returnTimeControlObject = puzzleTimeControlBuilder()
        const displayTime = returnTimeControlObject.display
        const valueTime = returnTimeControlObject.value
        for (var i=0; i < displayTime.length; i++) {
          const oneItem = { 
            index : i,
            name : displayTime[i],
            id : valueTime[i],
            radio : "" + valueTime[i]
          }
          optionDisplayArray.push(oneItem)
        }
        optionDisplaySelected = "" + initial
        openGenericSingleListModal()
        break
      case "when_timer_start" :
        const returnTimerStartObject = puzzleWhenTimerStartsBuilder()
        const displayTimer = returnTimerStartObject.display
        const valueTimer = returnTimerStartObject.value
        for (var i=0; i < displayTimer.length; i++) {
          const oneItem = { 
            index : i,
            name : displayTimer[i],
            id : valueTimer[i],
            radio : "" + valueTimer[i]
          }
          optionDisplayArray.push(oneItem)
        }
        optionDisplaySelected = "" + initial
        openGenericSingleListModal()
        break
      case "backup" :
        const returnVisualizeObject = puzzleVisualizeBuilder()
        const displayVisualize = returnVisualizeObject.display
        const valueVisualize = returnVisualizeObject.value
        for (var i=0; i < displayVisualize.length; i++) {
          const oneItem = { 
            index : i,
            name : displayVisualize[i],
            id : valueVisualize[i],
            radio : "" + valueVisualize[i]
          }
          optionDisplayArray.push(oneItem)
        }
        optionDisplaySelected = "" + initial
        openGenericSingleListModal()
        break
      case "blindfold" :
        const returnBlindfoldObject = puzzleBlindfoldBuilder()
        const displayBlindfold = returnBlindfoldObject.display
        const valueBlindfold = returnBlindfoldObject.value
        for (var i=0; i < displayBlindfold.length; i++) {
          const oneItem = { 
            index : i,
            name : displayBlindfold[i],
            id : valueBlindfold[i],
            radio : "" + valueBlindfold[i]
          }
          optionDisplayArray.push(oneItem)
        }
        optionDisplaySelected = "" + initial
        openGenericSingleListModal()
        break
      
      default :
        alert(optionSaveName + " not accounted for")
        break
    }
  }

  function getOptions(whichOption) {
    optionSaveName = whichOption

    optionDisplayArray = []

    switch (whichOption) {
      case "category" :
        optionHeading = t("Puzzle Categories")
        break;
      case "rating" :
        optionHeading = t("Puzzle Difficulty Rating")
        break;
      case "backup" :
        optionHeading = t("# of Moves to Visualize")
        break
      case "time" :
        optionHeading = t("Time Control")
        break
      case "when_timer_start" :
        optionHeading = t("When Timer Starts")
        break
      case "blindfold" :
        optionHeading = t("Blindfold Level")
        break
    }

    whichOptionIsGenericList = whichOption
    var formData = { 
      activity : puzzleType,
      option : whichOption
    }

    //console.log("formdata for puzzle option",formData)
    useGetData("chessvis_puzzle_get_option.php", formData, processOptionJsonResponse)
  }

  function processSetOptionJsonResponse(json) {
    //console.log("set option callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }
    if (puzzleState.value == PUZZLE_NONE)
      resetPuzzleScreen()
  }

  function setOptions(new_value) {
    var formData = { 
      activity : puzzleType,
      option : whichOptionIsGenericList,
      new_value : new_value

    }
    //console.log("formdata before set options",formData)
    useGetData("chessvis_puzzle_set_option.php", formData, processSetOptionJsonResponse)
  }

  // get initial option values 

  // stuff for options

  function findValueReturnIndex(valueArray,oneValue) {
    for (var i=0; i < valueArray.length; i++)
      if (valueArray[i] == oneValue)
        return (i)
    return (0)
  }

   function generateTotalPuzzleCount(countArray,minRating,maxRating) {
    if (minRating < 600)
      minRating = 600
    if (maxRating > 2800)
      maxRating = 2800
    const firstIndex = (minRating - 600) / 100
    const lastIndex = (maxRating - 600) / 100
    var puzzleTotal = 0
    for (var i=firstIndex; i < lastIndex; i++)
      puzzleTotal += countArray[i]
    return (puzzleTotal)
  }

  function processInitialOptionsJsonResponse(json) {
    //console.log(" get initial puzzle option callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    var returnObject = null

    var categoryValue = null
    var backupValue = null
    var timeValue = null
    var timerStartValue = null
    var blindfoldValue = null

    const catids = json['catids'].split(",")
    const counts = json['category_counts'].split(",")

    const currentRating = Number(json['current_rating'])
    const oldRatingRange = Number(json['old_rating_range'])
    const minRating = Number(json['min_rating'])
    const maxRating = Number(json['max_rating'])
    const selectUserRating = Number(json['select_user_rating'])
    const puzzleCountsStrings = json["puzzle_counts"].split(",")
    var puzzleCounts = []
    for (var i=0; i < puzzleCountsStrings.length; i++)
      puzzleCounts.push(Number(puzzleCountsStrings[i]))
    var count = 0
    switch (selectUserRating) {
      case 0 :
        if (oldRatingRange > 0) {
          count = generateTotalPuzzleCount(puzzleCounts,oldRatingRange,oldRatingRange+100)
          ratingDisplayString.value = t("Target Rating: Stay within") + " " +
                oldRatingRange + "-" + String(oldRatingRange + 99) + " (" + count.toLocaleString() + "}"
        }
        else
          ratingDisplayString.value = t("Target Rating") + ": " + currentRating + " (" + t("Your Rating") + ")"

        break
      case 1 :
        ratingDisplayString.value = t("Target Rating") + ": " + currentRating + " (" + t("Your Rating") + ")"
        break
      case 2 :
        count = generateTotalPuzzleCount(puzzleCounts,minRating,maxRating)
        ratingDisplayString.value = t("Target Rating: Stay within") + " " +
                minRating + "-" + String(maxRating - 1) + " (" + count.toLocaleString() + "}"
        break
    }

    //console.log("******* puzzletype ",puzzleType)
    switch (puzzleType) {
      case "solveit" :
        categoryValue = json["lichess_regular_initial"]
        returnObject = puzzleCategoryBuilder(catids,counts,"",categoryValue)
        categoryDisplayString.value = returnObject.displayToFind

        backupDisplayString.value = ""
        timeDisplayString.value = ""
        blindfoldDisplayString.value = ""
        break
      case "visualize" :
        categoryValue = json["lichess_visualize_initial"]      
        returnObject = puzzleCategoryBuilder(catids,counts,"",categoryValue)
        categoryDisplayString.value = returnObject.displayToFind   

        backupValue = json['backup_initial']
        returnObject = puzzleVisualizeBuilder(backupValue)
        //console.log("RETURN OBJECT",returnObject)
        backupDisplayString.value = t("Visualize") + ": " + returnObject.displayToFind

        timeDisplayString.value = ""
        blindfoldDisplayString.value = ""
        break
      case "timed" :
        categoryValue = json["lichess_timed_initial"]      
        returnObject = puzzleCategoryBuilder(catids,counts,"",categoryValue)
        categoryDisplayString.value = returnObject.displayToFind   

        timerStartValue = json['timer_start_initial']
        returnObject = puzzleWhenTimerStartsBuilder(timerStartValue)
        timerStartDisplayString.value = t("Starts") + " " + returnObject.displayToFind

        timerStartOnFirstMove = (timerStartValue == 1)
        timeValue = json['time_initial']
        returnObject = puzzleTimeControlBuilder(timeValue)
        timeDisplayString.value = t("Timed") + ": " + returnObject.displayToFind

        backupDisplayString.value = ""
        blindfoldDisplayString.value = ""
        break
      case "timed_visualize" :
        categoryValue = json["lichess_timed_visualize_initial"]
        returnObject = puzzleCategoryBuilder(catids,counts,"",categoryValue)
        categoryDisplayString.value = returnObject.displayToFind       

        backupValue = json['backup_timed_initial']
        returnObject = puzzleVisualizeBuilder(backupValue)
        //console.log("RETURN OBJECT",returnObject)
        backupDisplayString.value = t("Visualize") + ": " + returnObject.displayToFind

        timerStartValue = json['timer_start_initial']
        returnObject = puzzleWhenTimerStartsBuilder(timerStartValue)
        timerStartDisplayString.value = t("Starts") + " " + returnObject.displayToFind
        timerStartOnFirstMove = (timerStartValue == 1)

        timeValue = json['visualize_seconds_initial']
        returnObject = puzzleTimeControlBuilder(timeValue)
        timeDisplayString.value = t("Timed") + ": " + returnObject.displayToFind

        blindfoldDisplayString.value = ""
        break
      case "blindfold" :
        categoryValue = json["lichess_blindfold_initial"]      
        returnObject = puzzleCategoryBuilder(catids,counts,"",categoryValue)
        categoryDisplayString.value = returnObject.displayToFind   
        
        blindfoldValue = json['blindfold_initial']
        returnObject = puzzleBlindfoldBuilder(blindfoldValue)
        blindfoldDisplayString.value = t("Blindfold") + ": " + returnObject.displayToFind

        timeDisplayString.value = ""
        backupDisplayString.value = ""
        break
    }

  }

  function getInitialOptions() {
    var formData = { 
      activity : puzzleType
    }
    useGetData("chessvis_puzzle_initial_options.php", formData, processInitialOptionsJsonResponse)
  }

</script>


<style scoped>

.movelist-eighty-line {
  height : 2px;
  margin-bottom : 10px;
  background : rgb(13,110,253)
}


</style>